import { useStatsigClient, useStatsigUser } from '@statsig/react-bindings'
import { ARCHIVE_TO_FILTER } from 'constants/featureFlags'
import useToken from 'utils/hooks/useToken'

const useArchiveToFilter = () => {
  const { checkGate, isLoading } = useStatsigClient()
  const { user: statsigUser } = useStatsigUser()
  const { getUser } = useToken()
  const user = getUser()
  const isUserSyncPending = Boolean(
    user?.playerid &&
    (statsigUser?.userID?.toString() !== String(user.playerid) ||
      statsigUser?.email !== (user.email || undefined))
  )

  if (isLoading || isUserSyncPending) {
    return { enabled: false, isLoading: true }
  }

  try {
    return { enabled: checkGate(ARCHIVE_TO_FILTER), isLoading: false }
  } catch {
    return { enabled: false, isLoading: false }
  }
}

export default useArchiveToFilter
